import { Component, OnInit } from '@angular/core';
import { ActiveLinkCellComponent } from '@spartacus/organization/administration/components';
import { RouterLink } from '@angular/router';
import { NgTemplateOutlet } from '@angular/common';
import { ReverseUsernamePipe } from '../../../shared/pipes/revers-username.pipe';
import { UrlPipe } from '@spartacus/core';

@Component({
    selector: 'app-efa-active-link-cell',
    templateUrl: './efa-active-link-cell.component.html',
    imports: [RouterLink, NgTemplateOutlet, ReverseUsernamePipe, UrlPipe]
})
export class EfaActiveLinkCellComponent extends ActiveLinkCellComponent implements OnInit {

  ngOnInit(): void {
    console.log(this.property)
  }

}
